import * as React from "react";

function SvgScrollbarArrow(props) {
  return <svg width="1em" height="1em" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M11.75 16.279L4.686 9.215 11.75 2.15 9.6 0 .386 9.215 9.6 18.429l2.15-2.15z" fill="#1B39E2" /></svg>;
}

export default SvgScrollbarArrow;